import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "./Button";

const Header = () => {
    return (
        <section className="flex gap-12 items-center px-5 pt-48 mx-auto my-0 max-w-screen-xl max-md:flex-col max-md:px-5 max-md:py-10 max-sm:p-5">
            <div className="flex-1 mr-5">
                <img
                    src={`${process.env.REACT_APP_BASE_URL}/images/banner_img.png`}
                    alt="Placeholder"
                    className="w-full h-full object-cover"
                />
            </div>
            <motion.div
                className="flex-1 max-w-[630px] max-md:max-w-full"
                initial={{ opacity: 0, y: 50 }} // Start hidden & below
                whileInView={{ opacity: 1, y: 0 }} // Animate to normal
                transition={{ duration: 1, ease: "easeOut" }} // Smooth animation
                viewport={{ once: true }} // Only trigger once
            >
                <div className="relative mb-16">
                    <div>
                        <div className="relative">
                            <svg
                                width="153"
                                height="80"
                                viewBox="0 0 153 80"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="underline-svg absolute w-[153px] h-[78px] left-[-10px] top-[-10px] animate-draw"
                            >
                                <path
                                    d="M2.82687 66.758C17.8653 65.2062 48.7964 62.8268 63.7434 62.9303C100.928 63.1372 121.67 63.1372 149.856 66.6546C115.936 67.9478 55.2632 68.465 21.3428 72.8101C46.5391 71.31 98.884 72.2928 123.806 73.4825C106.724 74.2067 81.9543 73.3273 63.6824 78.1379"
                                    stroke="#ed8936"
                                    strokeWidth="3.57506"
                                    strokeDasharray="397.23"
                                    strokeDashoffset="397.23"
                                    className="animate-draw"
                                ></path>
                            </svg>
                        </div>
                    </div>
                    <h2 className="relative text-5xl italic font-bold leading-[57.6px] max-md:text-4xl max-md:leading-10 max-sm:text-3xl max-sm:leading-8">
                        <span className="text-orange-500">Excel</span>
                        <span> in English with</span>
                        <br />
                    </h2>
                </div>
                <p className="mb-8 text-lg leading-8 max-md:text-lg max-md:leading-7 max-sm:text-base max-sm:leading-6 text-justify">
                    iExcel International English provides comprehensive English tuition for
                    students aged 5 - 18. With over 20 years of experience, we help students
                    achieve academic success and gain confidence in English communication.
                </p>
                <div className="flex gap-5 max-sm:flex-col max-sm:w-full">
                    <Link to="/programs">
                        <Button variant="primary" text="Our Programs" />
                    </Link>
                    <Link to="/contact">
                        <Button variant="secondary" text="Contact Us" />
                    </Link>
                </div>
            </motion.div>
        </section>
    );
};

export default Header;